import { supabase } from '@/integrations/supabase/client';

export async function hasActiveJourneyPurchase(
  userId: string,
  journeyId: string,
  options: { throwOnError?: boolean } = {}
): Promise<boolean> {
  const { data, error } = await supabase.rpc('get_user_content_access_status', {
    p_user_id: userId,
    p_content_type: 'journey',
    p_content_id: journeyId,
  });

  if (error) {
    if (options.throwOnError) throw error;
    console.warn('Failed to check journey access:', error);
    return false;
  }

  if (options.throwOnError && typeof (data as { has_access?: unknown } | null)?.has_access !== 'boolean') throw new Error('The access check returned an unexpected response.');
  return Boolean((data as { has_access?: boolean } | null)?.has_access);
}
